<template>
  <div class='login_pop'>
    <img class="logo" :src="require(`@/assets/img/${device}/${region}/login/logo.png`)" alt="">
    <div class="tab_box">
      <span :class="loginType == 1 ? 'on' : ''" @click="loginType = 1">{{ $t('codeLogin') }}</span>
      <span :class="loginType == 2 ? 'on' : ''" @click="loginType = 2">{{ $t('pwdLogin') }}</span>
    </div>
    <div class="login_type login_type1" v-if="loginType == 1">
      <div class="phone_box">
        <div class="num">+86</div>
        <input type="text" :placeholder="$t('enterPhone')" v-model="phone.number" maxlength="20">
      </div>
      <div class="code_box">
        <input type="text" :placeholder="$t('enterVerifiCode')" maxlength="6" v-model="phone.code">
        <div class="code_btn">
          <div class="get_btn" v-if="waitTime == 0" @click="getPhoneCode">{{ $t('getVerifiCode') }}</div>
          <div class="get_no" v-else>{{ waitTime }}{{ $t('codeLoading') }}</div>
        </div>
      </div>
    </div>
    <div class="login_type login_type2" v-if="loginType == 2">
      <div class="account_box">
        <input type="text" :placeholder="$t('enterAccount')" v-model="account.number" maxlength="26">
      </div>
      <div class="pwd_box">
        <input :type="isHiddenPwd ? 'password' : 'text'" :placeholder="$t('enetrPwd')" v-model="account.pwd"
          maxlength="30">
        <i :class="`eye_i ${isHiddenPwd ? 'un' : 'on'}`" @click="isHiddenPwd = !isHiddenPwd"></i>
      </div>
    </div>
    <div :class="`agreement_box ${isAgreeAni ? 'agree_ani' : ''}`">
      <div class="select_box" @click="isAgree = !isAgree">
        <img :src="require(`@/assets/img/m/${region}/login/select_on.png`)" alt="" v-if="isAgree">
        <img src="@/assets/img/m/public/login/select_un.png" alt="" v-else>
      </div>
      <span v-html="$t('loginAgreement')"></span>
    </div>
    <div class="login_btn" v-if="loginType == 1" @click="phoneNumberLogin">{{ $t('login') }}</div>
    <div class="login_btn" v-if="loginType == 2" @click="accountLogin">{{ $t('login') }}</div>
  </div>
</template>

<script>
import { sendCode, phoneLogin, xcxPhoneLogin } from '@/api'
import { mapState } from 'vuex'
import { Toast } from 'vant'
export default {
  components: {},
  data() {
    return {
      loginType: 1, //1验证码 2账号
      waitTime: 0,
      isHiddenPwd: true,
      isAgree: false,
      isAgreeAni: false,
      account: {
        number: "",
        pwd: "",
      },
      phone: {
        number: '',
        code: '',
      },
      form: {//发短信参数
        action: 'page',
        method: 'send',
        appkey: 1486458782785,
        isMobileLogin: 1,
        account: '',
        sign: '',
        annex: ''
      },
    };
  },
  computed: {
    ...mapState(['device', 'region', 'wxProgram', 'loginStatus'])
  },
  watch: {},
  methods: {
    validatePhoneNumber(phoneNumber) {
      const phoneRegex = /^1[3-9]\d{9}$/;
      return phoneRegex.test(phoneNumber);
    },
    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    xcxLoginSubmit() {
      //小程序登录
      let params = {
        opentoken: this.$getQueryParam('loginToken'),
        openname: 'wechat',
        appkey: 1448278000000,
        device: `mp_vipmember${this.getRamNumber()}`,
        channel: 1000000002
      };
      xcxPhoneLogin(params).then((res) => {
        if (res.data.status == 1) {
          let info = res.data.data;
          if (info.userlist.length > 0) {
            info.userlist = info.userlist.filter(item => {//删除token为null的账号
              return item.create && item.token
            })
            info.userlist.sort((a, b) => {//按最新创建的游戏账户排序，防止使用未上架会员中心的老项目的token登录导致异常
              return new Date(b.create.replace(/-/g, '/')).getTime() - new Date(a.create.replace(/-/g, '/')).getTime()
            })
            localStorage.setItem('zlVipAccountId', info.accountid)
            localStorage.setItem('zlVipUserList', JSON.stringify(info.userlist))
            localStorage.setItem('zlVipSignature', info.signature)
            localStorage.setItem('zlVipExpire', info.expire)
            this.$store.commit('changeLoginStatus', 1)
          } else {
            Toast(this.$t('noAccount'))
          }
        } else {
          this.$requestFail(res.data.code)
        }
      });
    },
    loginSubmit(obj) {
      if (!this.isAgree) {
        this.isAgreeAni = true;
        setTimeout(() => {
          this.isAgreeAni = false;
        }, 400);
        return
      }
      let params = {
        appkey: 1448278000000,
        device: this.wxProgram ? `mp_vipmember${this.getRamNumber()}` : `vipmember${this.getRamNumber()}`,
        action: 'access',
        channel: '1000000002',
        ecid: '3010311001',
        version: 'v2',
        tag: 1,
        union_platform: 1
      };
      if (this.loginType == 1) {
        params.account = this.phone.number
        params.code = this.phone.code
      } else {
        params.account = this.account.number
        params.password = this.account.pwd
        //账号登录校验账号格式，后端暂时未做账号格式错误的返回处理
        if (!this.validatePhoneNumber(this.account.number) && !this.validateEmail(this.account.number)) {
          this.$requestFail(10112201)
          return
        }
      }
      if (obj) {//登录，增加滑块儿验证
        Object.assign(params, obj)
      }
      if (this.$route.path != '/') {//登录时返回首页
        this.$router.replace({ path: '/' })
      }
      let c = penc.ps(params);
      c.h.appkey = 1448278000000;
      phoneLogin({ d: c.d }, c.h).then((res) => {
        let b = {
          'zl-ret-nonce': res.headers['zl-ret-nonce'],
          'zl-ret-sign': res.headers['zl-ret-sign'],
          getResponseHeader: function (a) {
            return b[a];
          }
        };
        let dataInfo = penc.de(
          res.data.ret,
          b,
          res.config.headers['zl-p-nonce']
        );
        if (dataInfo.info == 10112206) {
          if (dataInfo.data.userlist.length == 0) {
            Toast(this.$t('noAccount'))
            return
          }
          let account = params.account.substring(0, 3) + '****' + params.account.substring(7)
          dataInfo.data.userlist = dataInfo.data.userlist.filter(item => {//删除token为null的账号
            return item.create && item.token
          })
          dataInfo.data.userlist.sort((a, b) => {//按最新创建的游戏账户排序，防止使用未上架会员中心的老项目的token登录导致异常
            return new Date(b.create.replace(/-/g, '/')).getTime() - new Date(a.create.replace(/-/g, '/')).getTime()
          })
          localStorage.setItem('zlVipAccountId', dataInfo.data.accountid)
          localStorage.setItem('zlVipUserList', JSON.stringify(dataInfo.data.userlist))
          localStorage.setItem('zlVipSignature', dataInfo.data.signature)
          localStorage.setItem('zlVipExpire', dataInfo.data.expire)
          this.$store.commit('changeLoginStatus', 1)
          if (this.wxProgram) {//小程序内，输入账号密码登录，返回小程序首页，让用户无法手动返回小程序的login页面
            wx.miniProgram.reLaunch({ url: '/pages/index/index' })
          }
        } else if (dataInfo.info == 15) {
          let _this = this
          return window.pdca && window.pdca.create(function (json) {
            if (json.status == "verify" && json.code == 0) {
              _this.loginSubmit({ ticket: json.ticket, rand: json.rand });
            }
          }, dataInfo.data.zlckey);
        } else {
          this.$requestFail(dataInfo.info)
        }
      });
    },
    accountLogin() {
      if (this.account.number.trim() == '') {
        Toast(this.$t('enterAccount'))
        return
      }
      if (this.account.pwd.trim() == '' || this.account.pwd.trim().length < 6) {
        Toast(this.$t('enetrPwd2'))
        return
      }
      this.loginSubmit()
    },
    phoneNumberLogin() {
      let phoneReg = /^1[3-9]\d{9}$/;
      if (phoneReg.test(this.phone.number)) {
        if (this.phone.code != '') {
          this.loginSubmit()
        } else {
          Toast(this.$t('enterVerifiCode'))
        }
      } else {
        Toast(this.$t('phoneStyle'))
      }
    },
    getPhoneCode() {
      if (this.waitTime == 0) {
        let phoneReg = /^1[3-9]\d{9}$/;
        if (!phoneReg.test(this.phone.number)) {
          Toast(this.$t('phoneStyle'))
        } else {
          this.form.account = this.phone.number;
          this.form.sign = this.$md5(
            this.$md5(this.phone.number + 'ACED000574') + 'ACED000574'
          );
          this.waitTime = 60;
          let timer1 = setInterval(() => {
            this.waitTime--;
            if (this.waitTime == 0) {
              clearInterval(timer1);
            }
          }, 1000);
          let c = penc.ps(this.form);
          c.h.appkey = 1486458782785;
          sendCode({ d: c.d }, c.h).then((res) => {
            let b = {
              'zl-ret-nonce': res.headers['zl-ret-nonce'],
              'zl-ret-sign': res.headers['zl-ret-sign'],
              getResponseHeader: function (a) {
                return b[a];
              }
            };
            let dataInfo = penc.de(
              res.data.ret,
              b,
              res.config.headers['zl-p-nonce']
            );
            if (dataInfo.status == 1) {
              //发送成功
            } else {
              this.$requestFail(dataInfo.info)
            }
          });
        }
      }
    },
    getRamNumber() {
      var result = '';
      for (var i = 0; i < 40; i++) {
        result += Math.floor(Math.random() * 16).toString(16); //获取0-15并通过toString转16进制
      }
      return result;
    },
    getWxProgram() {
      let _this = this
      // 获取当前环境
      const ua = navigator.userAgent.toLowerCase();
      if (
        ua.match(/MicroMessenger/i) &&
        ua.match(/MicroMessenger/i)[0] == 'micromessenger'
      ) {
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            // 在小程序环境内
            _this.$store.commit('changeWxProgram', true);
            if (_this.$getQueryParam('getLogin')) {
              wx.miniProgram.redirectTo({ url: '/pages/login/login' })
            }
          }
        });
      }
    },
  },
  created() {
    //小程序内，未登录状态下，手动拉起登录弹窗
    this.getWxProgram()
    if (this.$getQueryParam('loginToken')) {//小程序一键登录
      this.xcxLoginSubmit()
    }
  },
  mounted() {

  },
}
</script>
<style lang='less' scoped>
.login_pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #f397c1 0%, #fff 50%);
  overflow: hidden;

  .logo {
    width: 3.51rem;
    height: .92rem;
    margin-bottom: 1.62rem;
  }

  .tab_box {
    width: 6.24rem;
    display: flex;

    span {
      font-weight: bold;
      font-size: 0.28rem;
      color: @theme-default-grey;
      cursor: pointer;
    }

    span:nth-child(1) {
      margin-right: 0.26rem;
    }

    .on {
      display: inline-block;
      border-bottom: 0.04rem solid @theme-default-pink;
      color: @theme-default-pink;
    }
  }

  .login_type {
    width: 6.24rem;
    margin-top: 0.48rem;

    >div {
      width: 100%;
      height: 0.8rem;
      border-radius: 0.08rem;
      border: 0.01rem solid #fff;
      background: #fff;
      display: flex;
      align-items: center;
      box-shadow: 0.01rem 0.01rem 0.2rem 0.01rem rgba(0, 0, 0, 0.1);
      overflow: hidden;
    }

    .phone_box {
      .num {
        width: 0.98rem;
        height: 0.48rem;
        border-right: 0.02rem solid @theme-default-input-grey;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        font-size: 0.28rem;
        color: @theme-default-grey;
      }

      input {
        height: 0.48rem;
        width: calc(100% - 1rem);
        padding: 0 0.26rem;
        box-sizing: border-box;
        outline: none;
        border: none;
        font-size: 0.3rem;
      }
    }

    .code_box {
      overflow: hidden;
      margin-top: 0.32rem;

      input {
        width: 4rem;
        height: 0.48rem;
        padding: 0 0.16rem;
        box-sizing: border-box;
        outline: none;
        border: none;
        font-size: 0.3rem;
      }

      .code_btn {
        width: calc(100% - 4rem);
        height: 100%;

        >div {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.28rem;
          color: #ffffff;
        }

        .get_btn {
          background-color: @theme-default-pink;
        }

        .get_no {
          background-color: @theme-default-grey;
        }
      }
    }

    .account_box,
    .pwd_box {
      display: flex;
      align-items: center;
      position: relative;

      input {
        width: 100%;
        height: 0.48rem;
        padding: 0 0.16rem;
        padding-right: 0.6rem;
        box-sizing: border-box;
        outline: none;
        border: none;
        font-size: 0.3rem;
      }

      .eye_i {
        width: 0.39rem;
        height: 0.32rem;
        position: absolute;
        right: 0.2rem;
        transform: scale(0.8);
      }

      .eye_i.on {
        background: url('@/assets/img/m/public/login/pass_on.png');
        background-size: 100% 100%;
      }

      .eye_i.un {
        background: url('@/assets/img/m/public/login/pass_un.png');
        background-size: 100% 100%;
      }
    }

    .pwd_box {
      margin-top: 0.32rem;
    }
  }

  .agreement_box {
    width: 6.24rem;
    margin-top: 0.5rem;
    display: flex;
    align-items: center;
    font-size: 0.24rem;
    color: @theme-default-grey;

    .select_box {
      width: 0.3rem;
      height: 0.3rem;
      margin-right: 0.16rem;

      img {
        width: 100%;
        height: 100%;
      }
    }

    /deep/ a {
      color: #3555bc;
      text-decoration: none;
    }
  }

  .agree_ani {
    animation: agreeAni 200ms 2 linear;
  }

  @keyframes agreeAni {
    0% {
      transform: translateX(0rem);
    }

    25% {
      transform: translateX(-0.2rem);
    }

    50% {
      transform: translateX(0rem);
    }

    75% {
      transform: translateX(0.2rem);
    }

    100% {
      transform: translateX(0rem);
    }
  }

  .login_btn {
    width: 6.24rem;
    height: 0.88rem;
    border-radius: 0.44rem;
    background: @theme-default-pink;
    font-weight: bold;
    font-size: 0.28rem;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
  }
}
</style>